"use client";

import { LinkButton } from "@/components/links/LinkButton";
import { useSetAuthModalOpen } from "@/lib/clerk/useSetAuthModalOpen";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";
import { allowCommercialUse } from "@/utils/subscriptionLevels/allowCommercialUse";

export function PersonalUseText({ user }: { user: UserNoDates | null }) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);
  const setAuthModalOpen = useSetAuthModalOpen();

  const commercialUse =
    user !== null && allowCommercialUse(user.stripeSubscriptionId);

  if (commercialUse) {
    return null;
  }

  return (
    <>
      {" "}
      <LinkButton
        onClick={() => {
          if (user === null) {
            setAuthModalOpen();
            return;
          }
          setPricingModalOpen();
        }}
        className="text-sm"
      >
        Upgrade
      </LinkButton>{" "}
      for commercial use of your conversions.
    </>
  );
}
